import getResponseJson from './getresponsejson';

export const codingQueueFilterService = serviceRoutes => {
  const init = () => {
    return fetch(serviceRoutes.init, {
      credentials: 'include'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  const beginWork = contractId => {
    return fetch(serviceRoutes.beginWork, {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ contractId })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      // if result < 1 then no encounters were found
      return result;
    });
  };

  return {
    init,
    beginWork,
    serviceRoutes
  };
};

export default codingQueueFilterService;
